import React from "react";

function BasketIcon({ stroke }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.49704 12.1805C4.64049 9.49072 4.71222 8.14585 5.5802 7.32292C6.44819 6.5 7.79497 6.5 10.4885 6.5H13.5114C16.205 6.5 17.5518 6.5 18.4198 7.32292C19.2877 8.14585 19.3595 9.49072 19.5029 12.1805L19.6629 15.1805C19.8211 18.1456 19.9001 19.6281 19.0128 20.5641C18.1254 21.5 16.6408 21.5 13.6714 21.5H10.3285C7.3592 21.5 5.87454 21.5 4.98719 20.5641C4.09983 19.6281 4.1789 18.1456 4.33704 15.1805L4.49704 12.1805Z"
        stroke={ stroke }
        strokeWidth="2"
      />
      <path
        d="M9 5.5C9 3.84325 10.3433 2.5 12 2.5C13.6568 2.5 15 3.84325 15 5.5"
        stroke={ stroke }
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BasketIcon;
